//
//component
import { Badge, Button, Card, Flex, Typography } from "antd";
import { AiOutlineBell } from "react-icons/ai";
import { IoRefresh } from "react-icons/io5";
//redux
//selector
//actions
import { getUnfinishedTask } from "store/bailiff/task/task_count/task_count.action";
//utils
//hook
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { unfinishedTaskCountSelector } from "store/bailiff/task/task_count/task_count.selector";
//str

const NotificationCard = () => {
  // -------------------------- VAR -----------------------------
  const size = 16;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const unfinishedTasks = useSelector(unfinishedTaskCountSelector);
  const label =
    unfinishedTasks === 0
      ? "Không còn việc làm nào"
      : `Còn lại ${unfinishedTasks} việc làm`;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLeft = () => {
    return (
      <Flex gap={12} align="center">
        <Badge dot size="small">
          <AiOutlineBell size={size} />
        </Badge>
        <Typography.Text style={{ margin: 0 }}>{label}</Typography.Text>
      </Flex>
    );
  };

  const handleRefresh = () => {
    dispatch(getUnfinishedTask());
  };
  // -------------------------- MAIN ----------------------------
  if (unfinishedTasks <= 0) return null;

  return (
    <Card className="mb-5">
      <Flex justify="space-between" align="center">
        {renderLeft()}
        <Button
          onClick={handleRefresh}
          icon={
            <span className="anticon">
              <IoRefresh size={size} />
            </span>
          }
        >
          Tải lại
        </Button>
      </Flex>
    </Card>
  );
};
export default NotificationCard;
